/*!
 * Copyright © 2018-2019. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

import { IMapContextMenuPermissions, GeofenceMarkerInfo, LatLng, IMapContextMenuData } from '../../../core/models';

@Component({
  selector: 'fm-geofence-menu-content',
  templateUrl: './geofence-menu-content.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GeofenceMenuContentComponent {
  @Input()
  public menuData: IMapContextMenuData<GeofenceMarkerInfo>;

  @Input()
  public userPermissions: IMapContextMenuPermissions;

  @Output()
  public closed: EventEmitter<void> = new EventEmitter();

  @Output()
  public findNearestClicked: EventEmitter<void> = new EventEmitter();

  @Output()
  public zoomToClicked: EventEmitter<void> = new EventEmitter();

  @Output()
  public streetViewClicked: EventEmitter<void> = new EventEmitter();

  @Output()
  public editPlaceClicked: EventEmitter<void> = new EventEmitter();

  @Output()
  public getDirectionToClicked: EventEmitter<void> = new EventEmitter();

  @Output()
  public getDirectionFromClicked: EventEmitter<void> = new EventEmitter();

  @Output()
  public locationToGarminClicked: EventEmitter<LatLng> = new EventEmitter();

  public onFindNearestClicked(): void {
    this.findNearestClicked.emit();
    this.closed.emit();
  }

  public onZoomToClicked(): void {
    this.zoomToClicked.emit();
    this.closed.emit();
  }

  public onStreetViewClicked(): void {
    if (this.menuData.streetViewAvailable) {
      this.streetViewClicked.emit();
      this.closed.emit();
    }
  }

  public onEditPlaceClicked(): void {
    this.editPlaceClicked.emit();
    this.closed.emit();
  }

  public onGetDirectionToClicked(): void {
    this.getDirectionToClicked.emit();
    this.closed.emit();
  }

  public onGetDirectionFromClicked(): void {
    this.getDirectionFromClicked.emit();
    this.closed.emit();
  }

  public onLocationToGarminClicked(): void {
    this.locationToGarminClicked.emit(this.menuData.clickLatLng);
    this.closed.emit();
  }
}
